//#region src/properties/pickSrcSetUri.ts
var e = 3 / 2, t = (t, n, { width: r, height: i, scale: a }) => {
	if (!t) return n;
	let o = t.split(",").map((e) => e.trim().split(/\s+/)).map(([e, t]) => ({
		uri: e,
		width: Number.parseInt(t ?? "", 10)
	})).filter((e) => !!e.uri && Number.isFinite(e.width) && e.width > 0).sort((e, t) => e.width - t.width);
	if (!o.length) return n;
	let s = Math.max(r, i * e) * a;
	return (o.find((e) => e.width >= s) ?? o[o.length - 1]).uri;
};
//#endregion
export { t as pickSrcSetUri };
